// /src/components/RibbonUtils.jsx

import React, { useMemo, useEffect } from 'react';
import default_ribbon from '../medias/default-ribbon.svg';
import { createDynamicCSS } from '../../utils/CreateDynamicCSS';

// Fonction pour calculer les tailles des rectangles dans le ribbon
const calculateRectSizes = (ribbon) => {
    //console.log('[RibbonUtils] calculateRectSizes for', ribbon);
  const rectWidth = 9.8;
  const rectSpacing = 1.3;
  const rectSizes = new Array(8).fill(`${rectWidth}%`);
  let index = 0;

  while (index < 7) {
    if (ribbon.links && ribbon.links[`link${index + 1}`]) {
      let start = index;
      while (index < 7 && ribbon.links[`link${index + 1}`]) {
        index++;
      }
      const groupSize =
        (index - start + 1) * rectWidth +
        (index - start) * rectSpacing;
      rectSizes[start] = `${groupSize}%`;
      for (let i = start + 1; i <= index; i++) {
        rectSizes[i] = '0%';
      }
    }
    index++;
  }

  return rectSizes;
};

const normalizeClassName = (index, color, width) => {
  const safeColor = color.replace('#', '');
  const safeWidth = width.replace('%', '').replace('.', '-');
  const name = `ribbon-rect-${index}-${safeColor}-${safeWidth}`;
  //console.log('[RibbonUtils] normalizeClassName =>', name);
  return name;
};

const RibbonDisplay = ({ ribbon }) => {
    //console.log('[RibbonUtils] RibbonDisplay mount, ribbon=', ribbon);
  if (!ribbon) return null;

  // 1) Calcul des tailles (memoisé)
  const rectSizes = useMemo(
    () => calculateRectSizes(ribbon),
    [ribbon]
  );

  // 2) Préparation des entrées [key, color, width]
  const colorEntries = useMemo(
    () =>
      Object.keys(ribbon.colors).map((key, i) => [
        key,
        ribbon.colors[key],
        rectSizes[i],
      ]),
    [ribbon.colors, rectSizes]
  );

  // 3) Injection des règles CSS **une seule fois** après le mount
  useEffect(() => {
    //console.log('[RibbonUtils] useEffect inject CSS for', colorEntries);
    colorEntries.forEach(([colorKey, color, width], index) => {
      if (!color || width === '0%') return;
      const className = normalizeClassName(index, color, width);
      createDynamicCSS(className, {
        backgroundColor: color,
        width: width,
      });
    });
  }, [colorEntries]);

  // 4) Render des rectangles, la classe existe déjà côté CSS
  return (
    <div className="ribbon-details">
      <div className="ribbon-colors">
        <div className="selected-ribbon-container ribbon-utils">
          <div className="ribbon-overlay-container">
            <img
              src={default_ribbon}
              alt="Selected Ribbon"
              className="ribbon-image"
            />
            {colorEntries.map(([colorKey, color, width], index) => {
              if (!color || width === '0%') return null;
              const className = normalizeClassName(
                index,
                color,
                width
              );
              const imageUrl =
                ribbon.images?.[`imageUrl${index + 1}`];
              return (
                <div
                  key={index}
                  className={`color-rect rect-${
                    index + 1
                  } color-selected ${className}`}
                >
                  {imageUrl && (
                    <img
                      src={imageUrl}
                      alt="Group Image"
                      className="group-image"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RibbonDisplay;
